/* Get url config based on process.env.SONET_STAGE */
export enum SONET_STAGE {
  DEV = "dev",
  PROD = "prod",
  IP = "ip",
  GYOMU = "g",
  MV = "mv",
}
export const getUrlConfig: any = () => {
  const getEnv = () => {
    const sonetStage = process.env.REACT_APP_SONET_STAGE;
    switch (sonetStage) {
      case SONET_STAGE.DEV:
      case SONET_STAGE.PROD:
      case SONET_STAGE.IP:
      case SONET_STAGE.GYOMU:
      case SONET_STAGE.MV:
        return sonetStage;
      default:
        return SONET_STAGE.DEV;
    }
  };
  const sonetStage = getEnv();
  return require(`../config/urlConfig/urlConfig.${sonetStage}.json`);
};
